<script>
import { commands } from '../../js/lib/functions.js'
import { navigate } from '@trullock/page-manager'
import DateTime from '../../../functions/lib/dateTime.js';
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { showToast } from '../../js/utils/toast.js';
import { listenToCurrentUserView } from '../../js/readModel.js';
import { cropImage } from '../../js/utils/cropper.js';

export const pageName = 'account';
export const pageRoute = '/account';
export const title = 'Account';
export const requireEmailVerified = false;

export default {
	data() {
		return { 
			user: null,
			name: '',
			email: '',
			bornOn: null,
			avatar: null,
			
			files: [],

			isDirty: false,

			ready: false,
			maxDob: DateTime.today,
			minDob: DateTime.today.addYears(-120)
		}
	},
	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async boot(opts) {
			await listenToCurrentUserView(user => this.user = user);
		},
		async show()
		{
			commands.warmUp();

			this.name = this.user.name;
			this.email = this.user.email;
			this.avatar = this.user.avatar;
			this.newAvatar = false;
			this.bornOn = this.user.bornOn?.format('yyyy-MM-dd');
			this.files = [];
			
			this.ready = true;
			this.isDirty = false;
		},
		hide()
		{
			this.$refs.fupAvatar.value = null
			this.$refs.lblAvatar.innerHTML = "Choose image&hellip;";
		},
		crop() {
			showLoading();

			this.modal.hide();

			// use a separate "thread" because of UI locking
			setTimeout(() => {
				
				let canvas = this.cropper.getCroppedCanvas({
					width: 240,
					height: 240
				});

				
				
				hideLoading();

			}, 1);
		},
		
		inputChanged(e) {

			var files = e.target.files;

			this.$refs.fupAvatar.setCustomValidity('');
			this.$refs.fupAvatar.reportValidity();

			if (files && files.length > 0) {
				let file = files[0];

				this.$refs.fupAvatar.value = '';
				this.$refs.fupAvatar.blobData = null;
				
				cropImage({
					aspectRatio: 1,
					viewMode: 1,
					autoCropArea: 1
				}, { 
					width: 240, 
					height: 240 
				}, file).then(canvas => {
					this.avatar = canvas.toDataURL();
					this.newAvatar = this.avatar;

					canvas.toBlob(blob => {
						this.$refs.fupAvatar.blobData = {
							blob: blob,
							name: 'avatar.jpg'
						};

						this.$refs.lblAvatar.innerText = file.name;
					});
				}, e => {
					if(e instanceof Error)
					{
						this.$refs.fupAvatar.setCustomValidity(e.message);
						this.$refs.fupAvatar.reportValidity();
					}
				})
			}
		},
		changed() {
			this.isDirty = true;
		},
		async submit() {
			
			showLoading();

			// new need copies because the update listener replaces the new values
			let newName = this.name;
			let newBornOn = new DateTime(this.bornOn);

			let result = await commands.users.account.changeName({ name: newName });
			if(!result.success)
			{
				showToast({ message: 'Error changing your name', style: 'bg-danger'})
				hideLoading();
				return;
			}

			result = await commands.users.account.changeBornOn({ bornOn: newBornOn })
			if(!result.success)
			{
				showToast({ message: 'Error changing your date of birth', style: 'bg-danger'})
				hideLoading();
				return;
			}

			if(this.newAvatar)
			{
				result = await commands.users.account.changeAvatar({ avatar64: this.newAvatar});
				if(!result.success)
				{
					showToast({ message: 'Error changing your avatar', style: 'bg-danger'})
					hideLoading();
					return;
				}
			}
			
			this.isDirty = false;

			navigate('/')

			showToast({
				message: 'Account updated',
				style: 'bg-success'
			})

			hideLoading();
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit" @change="changed">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">
				<h1 class="display-4 text-center mb-3">Profile</h1>
				<p class="text-muted text-center mb-5">Change your details.</p>
					
				<fieldset>
					<div class="form-group">
						<label>Name</label>
						<input type="text" class="form-control" name="name" v-model="name" autocomplete="name" placeholder="First Last" required />
						<span class="invalid-feedback"></span>
					</div>
					<div class="form-group">
						<label>Date of birth</label>
						<input type="date" class="form-control" ref="dob" v-model="bornOn" required :max="`${maxDob.format('yyyy-MM-dd')}`" :min="`${minDob.format('yyyy-MM-dd')}`"/>
						<span class="invalid-feedback"></span>
					</div>
				</fieldset>
				<fieldset>
					<div class="field form-group mb-0">
						<label class="d-block">
							Photo ID
							
							<div class="row justify-content-center my-3">
								<div class="col">
									<div class="dz-default dz-message py-4">
										<div class="avatar avatar-xxl">
											<img ref="imgAvatar" class="avatar-img rounded-circle" :src="avatar" alt="Avatar">
										</div>
									</div>
								</div>
							</div>
						</label>
						<div class="alert alert-secondary"><span class="fe fe-alert-triangle"></span> Your picture must be a good quality portrait of yourself and will be used for membership verification at launches.</div>
						<div class="custom-file">
							<input type="file" @change="inputChanged" ref="fupAvatar" class="custom-file-input" accept="image/*;capture=camera">
							<label ref="lblAvatar" class="custom-file-label text-muted">Choose image&hellip;</label>
							<span class="invalid-feedback"></span>
						</div>
						<span class="form-text text-muted small mb-0">Must be a jpeg or png</span>
					</div>
				</fieldset>
				<hr class="my-5" />
				
				<button type="submit" class="btn btn-lg btn-primary btn-block">Save changes <span class="fe fe-check-circle"></span></button>
			</div>
		</div>
	</form>
</div>

</template>